import { useMutation, useQuery } from '@tanstack/react-query'
import {
  getResellerInvitationInfo,
  acceptResellerInvitation,
  type ResellerInvitationInfoDto,
  type AcceptResellerInvitationDto,
} from '../reseller-invitation'

export const useGetResellerInvitationInfo = (invitationCode: string) => {
  return useQuery<ResellerInvitationInfoDto>({
    queryKey: ['resellerInvitation', invitationCode],
    queryFn: () => getResellerInvitationInfo(invitationCode),
    enabled: !!invitationCode,
    retry: false,
  })
}

export const useAcceptResellerInvitation = () => {
  return useMutation<{ message: string }, Error, AcceptResellerInvitationDto>({
    mutationFn: acceptResellerInvitation,
  })
}
